import { PERSONNEL_REGISTATION_ACTION_TYPES } from 'store/actions/personnel.actions';

const initialState = {
  listOrganizations: [],
  researchSiteProblems: {},
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_REGISTATION_SEARCH_ORG:
      return { ...state, searchOrganizations: payload.data };

    case PERSONNEL_REGISTATION_ACTION_TYPES.GET_JOB_TITLES_FOR_RESEARCH:
      return { ...state, jobTitlesForResearch: payload.data };

    case PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: { ...payload.data } };

    case PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_CLEAR_STATE:
      if (payload.shouldDeleteProperty) {
        const { [payload.clearedKey]: clearedKey, ...stateTail } = state;
        return { ...stateTail };
      } else {
        return { ...state, [payload.clearedKey]: {} };
      }

    default:
      return state;
  }
}
